import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const VerticalCardContainer = styled.div<
  React.CSSProperties & { focused?: boolean; hide?: boolean }
>`
  border: ${4 * Screen.widthRatio}px solid
    ${(props) => (props.focused ? 'white' : 'transparent')};
  border-radius: ${26 * Screen.widthRatio}px;
  cursor: pointer;
  float: left;
  display: ${(props) => (props.hide ? 'none' : 'block')};

  height: ${300 * Screen.widthRatio}px;
  margin-right: ${4 * Screen.widthRatio}px;
  overflow: hidden;
  width: ${200 * Screen.widthRatio}px;
  &:hover {
    border: ${4 * Screen.widthRatio}px solid white;
  }
`;

export default VerticalCardContainer;
